import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Source from './icon-lead-stage-goal.svg';

type Props = {
    fill?: string;
};

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <Source {...validProps} color={validProps.fill || '#7A7370'} />;
}
SvgComponent.iconName = 'goalLeadStage';

/**
 * @deprecated This is a legacy icon
 */
export const GoalLeadStageIcon = svgIconWrapper(SvgComponent);
